import React from 'react';
import { SegmentedControl } from '../SegmentedControl';
interface TimeSelectorProps {
  value: string;
  onChange: (value: string) => void;
}
export function TimeSelector({
  value,
  onChange
}: TimeSelectorProps) {
  const options = [{
    value: 'today',
    label: 'Today'
  }, {
    value: '7d',
    label: 'Last 7 days'
  }, {
    value: '30d',
    label: 'Last 30 days'
  }, {
    value: 'year',
    label: 'This year'
  }, {
    value: 'all',
    label: 'All time'
  }];
  return <SegmentedControl options={options} value={value} onChange={onChange} className="w-auto" data-id="element-2718" />;
}